import React from "react";
import remarkGfm from "remark-gfm";

// Shared config for the AI Markdown renderers (News AI / Raeinexchange AI).
// Kept at module scope so the array/object identities stay stable across renders.
export const REMARK_PLUGINS = [remarkGfm];

export const MD_COMPONENTS = {
  h1: ({ node, ...p }) => <h3 className="text-emerald-300 text-base font-semibold mt-4 mb-1.5" {...p} />,
  h2: ({ node, ...p }) => <h3 className="text-emerald-300 text-base font-semibold mt-4 mb-1.5" {...p} />,
  h3: ({ node, ...p }) => <h4 className="text-emerald-300 text-sm font-semibold mt-3 mb-1" {...p} />,
  p: ({ node, ...p }) => <p className="text-zinc-300 mb-2" {...p} />,
  ul: ({ node, ...p }) => <ul className="list-disc pl-5 space-y-1 mb-2 text-zinc-300" {...p} />,
  ol: ({ node, ...p }) => <ol className="list-decimal pl-5 space-y-1 mb-2 text-zinc-300" {...p} />,
  li: ({ node, ...p }) => <li className="text-zinc-300" {...p} />,
  strong: ({ node, ...p }) => <strong className="text-white font-semibold" {...p} />,
  em: ({ node, ...p }) => <em className="text-zinc-200" {...p} />,
  hr: () => <hr className="border-white/10 my-3" />,
  table: ({ node, ...p }) => <div className="overflow-x-auto my-2"><table className="w-full text-xs border border-white/10" {...p} /></div>,
  th: ({ node, ...p }) => <th className="border border-white/10 px-2 py-1 text-left bg-white/5 text-zinc-200" {...p} />,
  td: ({ node, ...p }) => <td className="border border-white/10 px-2 py-1 text-zinc-300 font-mono" {...p} />,
};
